import { useModalManager } from '../../../../hooks/ModalManager.hook';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../hooks/useAppDispatcher.hook';
import { ALERT_ACTION_ENUM } from '../../../../types/action.types';
import ApiWrapper from '../../../../hooks/useApi.hook';
import { destroyPersonThunk } from '../../../../redux/Candidate/Candidate.thunk';
import { StyledIconButtonWrapper } from '../Candidate.styled';
import IconButtonComponent from '../../../../components/IconButton.component';
import { setIsEditCandidateAction } from '../../../../redux/Candidate/Candidate.slice';
import PersonEditModalComponent from '../../../../components/Modal/Candidate/PersonEditModal.component';
import {
  HEADER_ACTIONS_ICONS,
  HeaderActionIcons,
} from '../../../../components/Icons/HeaderAction.icons';
import CandidateRemoveAlertComponent from '../../../../components/Alert/Candidate/CandidateRemoveAlert.component';
import React from 'react';
import ShareIcon from '../../../../components/Icons/Share.icon';

type CandidateActionsPanelProps = {
  candidate: any;
  hasUserPermissionToEditCandidate: boolean;
  hasUserPermissionToDeleteCandidate: boolean;
  canCopyInvitationLink?: boolean;
  onCopyInvitationLink?: () => void | Promise<void>;
  copyInvitationLinkTitle?: string;
};

export const CandidateActionsPanel: React.FC<CandidateActionsPanelProps> = ({
  candidate,
  hasUserPermissionToEditCandidate,
  hasUserPermissionToDeleteCandidate,
  canCopyInvitationLink,
  onCopyInvitationLink,
  copyInvitationLinkTitle,
}) => {
  const { openModal } = useModalManager();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleConfirmDelete = (action?: ALERT_ACTION_ENUM) => {
    if (!action || !candidate) return;
    if (action && action !== ALERT_ACTION_ENUM.YES) return;
    ApiWrapper(destroyPersonThunk(candidate.id)).then((res: boolean) => {
      res && navigate(-1);
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
      {canCopyInvitationLink && onCopyInvitationLink && (
        <StyledIconButtonWrapper>
          <IconButtonComponent
            onClick={() => {
              onCopyInvitationLink();
            }}
            title={copyInvitationLinkTitle}
          >
            <ShareIcon width={18} height={18} />
          </IconButtonComponent>
        </StyledIconButtonWrapper>
      )}

      {hasUserPermissionToEditCandidate && (
        <StyledIconButtonWrapper>
          <IconButtonComponent
            onClick={() => {
              dispatch(setIsEditCandidateAction(true)); // ! странно. можно ли от этого уйти?
              openModal(
                PersonEditModalComponent,
                { info: candidate, isCandidatePage: true },
                { disableClose: false },
              );
            }}
          >
            {HEADER_ACTIONS_ICONS[HeaderActionIcons.EDIT]}
          </IconButtonComponent>
        </StyledIconButtonWrapper>
      )}

      {hasUserPermissionToDeleteCandidate && (
        <StyledIconButtonWrapper>
          <IconButtonComponent
            onClick={() => {
              openModal(CandidateRemoveAlertComponent, {
                handleConfirm: handleConfirmDelete,
              });
            }}
          >
            {HEADER_ACTIONS_ICONS[HeaderActionIcons.DELETE]}
          </IconButtonComponent>
        </StyledIconButtonWrapper>
      )}
    </div>
  );
};
